module.exports = __webpack_public_path__ + "img/logo-ovo_qris2-active.e831c437.svg";